"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const configs = {
    size: {
        sm: "h-4 w-4",
        md: "h-5 w-5",
        lg: "h-6 w-6",
    },
};
exports.default = configs;
